"use client";
import React, { useEffect, useState } from "react";
import "./deals.css";

import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Autocomplete, { createFilterOptions } from "@mui/joy/Autocomplete";
import AutocompleteOption from "@mui/joy/AutocompleteOption";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Add from "@mui/icons-material/Add";
import { craveProvincesRes } from "../finder/data.js";
import QRCode from "qrcode.react";
import { fetchAPI } from "../../utils/api.js";
import jwt from "jsonwebtoken";
import { Alert } from "@mui/material";

const filter = createFilterOptions();

const DealsFinder = () => {
  const [provinces, setProvinces] = useState([]);
  const [province, setProvince] = useState("");
  const [value, setValue] = useState(null);
  const [selectedDiscountType, setSelectedDiscountType] = useState("all");
  const [keywords, setKeywords] = useState([]);
  const [deals4U, setDeals4U] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const [selectedDeals4U, setSelectedDeals4U] = useState(null);
  const [showQrModal, setShowQrModal] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [showTsAndCsModal, setShowTsAndCsModal] = useState(false);
  const [hasAcceptedTsAndCs, setHasAcceptedTsAndCs] = useState(false);
  const [filteredDeals, setFilteredDeals] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [token, setToken] = useState(null);

  const handleChange = (event) => {
    setProvince(event.target.value);
  };

  const requestVoucherData = async (amount) => {
    setIsLoading(true);

    fetchAPI(
      "/CCVoucherPaymentRequestMyVirtual",
      "POST",
      {
        MemberID:
          typeof window !== "undefined" &&
          window.localStorage.getItem("flp-member-id"),
        Company: 55,
        PaymentAmount: amount,
      },
      token
    )
      .then((res) => {
        if (res?.CO_ID) {
          handleAdumoPayment(res);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setIsLoading(false);
      });
  };

  const handleAdumoPayment = async (virtualResponse) => {
    const payload = {
      iss: virtualResponse?.CO_ID,
      cuid: virtualResponse?.MerchantIdReference,
      auid: virtualResponse?.ApplicationIdReference,
      amount: virtualResponse?.CC_Amount,
      mref: virtualResponse?.Reference,
      iat: Date.now() / 1000 - 60,
      exp: Date.now() / 1000 + 600,
    };

    // Generate the JWT token with your payload
    const token = jwt.sign(payload, virtualResponse?.Jti);

    // send data to adumo for payment
    const formData = new FormData();
    formData.append("flow", "CARD");
    formData.append("MerchantID", virtualResponse?.MerchantIdReference);
    formData.append("ApplicationID", virtualResponse?.ApplicationIdReference);
    formData.append("MerchantReference", virtualResponse?.Reference);
    formData.append("Token", token);
    formData.append("Amount", virtualResponse?.CC_Amount);
    formData.append("puid", virtualResponse?.puid);
    formData.append("RedirectSuccessfulURL", virtualResponse?.SuccessUrl);
    formData.append("RedirectFailedURL", virtualResponse?.FailureUrl);
    formData.append("DisplayPrice", virtualResponse?.CC_Amount);
    formData.append("txtCurrencyCode", "ZAR");

    fetch(`${process.env.NEXT_PUBLIC_PROXY_URL}/adumo-payment`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        if (typeof window !== "undefined") {
          window.location.replace(data);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      setToken(window.localStorage.getItem("flp-access-token"));
    }
  }, []);

  useEffect(() => {
    craveProvincesRes
      .then((res) => {
        if (res?.Data) {
          setProvinces(res.Data);
          setProvince(res.Data[0]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    setIsFetching(true);

    fetch("https://dolphin-app-fdfp4.ondigitalocean.app/api/deals4U")
      .then((response) => response.json())
      .then((data) => {
        setDeals4U(data);

        setFilteredDeals(data);

        setKeywords(
          data.reduce((acc, item) => {
            if (item?.keywords) {
              acc.push(...item.keywords);
            }

            return acc;
          }, [])
        );

        setIsFetching(false);
      })
      .catch((error) => {
        console.error("Error:", error);

        setIsFetching(false);
      });
  }, []);

  useEffect(() => {
    // filter deals based on selected discount type
    const filteredDeals = deals4U.filter((deal) => {
      return deal?.type?.toLowerCase() === selectedDiscountType;
    });

    if (
      !deals4U.every((deal) =>
        deal?.title.toLowerCase().includes("night midweek")
      )
    ) {
      setFilteredDeals(
        selectedDiscountType === "all" ? deals4U : filteredDeals
      );
    }
  }, [selectedDiscountType]);

  return (
    <div className="main-page-container">
      {/* search filter start */}
      <div className="filter-wrapper">
        <div className="filter">
          <div>
            <h4
              className="search-title"
              style={{ textAlign: "center", color: "red" }}
            >
              REFINE YOUR SEARCH
            </h4>
          </div>

          <hr className="solid" />

          <div className="province-dropdown">
            <h4 className="search-title">PROVINCE</h4>

            <Box className="dropdown" sx={{ minWidth: 120 }}>
              <FormControl className="control" fullWidth>
                <Select
                  sx={{ ".MuiOutlinedInput-notchedOutline": { border: 0 } }}
                  value={province}
                  onChange={handleChange}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  style={{ padding: "-10px" }}
                >
                  {provinces.map((item) => (
                    <MenuItem key={item} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>

            <hr className="solid" />

            <div className="discount-type">
              <h4 className="search-title">DISCOUNT TYPE AVAILABLE</h4>

              <div className="radio-parent">
                <div className="search-title child-1">
                  ALL
                  <br />
                  <br />
                  FASHION
                  <br />
                  <br />
                  ONLINE
                  <br />
                  <br />
                  LIFESTYLE
                  <br />
                  <br />
                  HOME
                  <br />
                  <br />
                  ELECTRONICS
                  <br />
                </div>

                <div className="child-2">
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      value={selectedDiscountType}
                      name="radio-buttons-group"
                      onChange={(e) => {
                        setSelectedDiscountType(e.target.value);
                      }}
                    >
                      <FormControlLabel value="all" control={<Radio />} />
                      <FormControlLabel value="fashion" control={<Radio />} />
                      <FormControlLabel value="online" control={<Radio />} />
                      <FormControlLabel value="lifestyle" control={<Radio />} />
                      <FormControlLabel value="home" control={<Radio />} />
                      <FormControlLabel
                        value="electronics"
                        control={<Radio />}
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
              </div>

              <hr className="solid" />

              <div className="keyword-search">
                <h4 className="search-title" style={{ marginBottom: "10px" }}>
                  KEYWORD
                </h4>

                <FormControl id="free-solo-with-text-demo">
                  <Autocomplete
                    placeholder="ENTER KEYWORD"
                    value={value}
                    onChange={(event, newValue) => {
                      if (typeof newValue === "string") {
                        setValue({
                          title: newValue,
                        });
                      } else if (newValue && newValue.inputValue) {
                        // Create a new value from the user input
                        setValue({
                          title: newValue.inputValue,
                        });
                      } else {
                        setValue(newValue);
                      }
                    }}
                    filterOptions={(options, params) => {
                      const filtered = filter(options, params);

                      const { inputValue } = params;
                      // Suggest the creation of a new value
                      const isExisting = options.some(
                        (option) => inputValue === option
                      );
                      if (inputValue !== "" && !isExisting) {
                        filtered.push({
                          inputValue,
                          title: `Add "${inputValue}"`,
                        });
                      }

                      return filtered;
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    freeSolo
                    options={keywords}
                    getOptionLabel={(option) => {
                      return option;
                    }}
                    renderOption={(props, option) => (
                      <AutocompleteOption {...props}>
                        {option?.startsWith('Add "') && (
                          <ListItemDecorator>
                            <Add />
                          </ListItemDecorator>
                        )}

                        {option}
                      </AutocompleteOption>
                    )}
                    sx={{ width: 300 }}
                  />
                </FormControl>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* search filter end */}

      <div className="results">
        {!(
          typeof window !== "undefined" &&
          window.localStorage.getItem("flp-token")
        ) && (
          <Alert severity="warning" className="deals-alert">
            Note: To purchase voucher or view discount, you have to{" "}
            <a href={"/?p=login"} className="link">
              log in
            </a>{" "}
            first.
          </Alert>
        )}
        {!isFetching ? (
          deals4U.length > 0 ? (
            filteredDeals.map((deal, index) => (
              <React.Fragment key={index}>
                <div
                  key={index}
                  className={`resturant-result ${
                    deal?.title.toLowerCase().includes("night midweek")
                      ? "voucher-bg"
                      : ""
                  }`}
                >
                  {/* Restaurant result start */}
                  <div className="resturant-result-child-1">
                    <div>
                      {deal?.title.toLowerCase().includes("night midweek") && (
                        <span className="premium_deal_label">Premium Deal</span>
                      )}
                      <img src={deal?.main_image_path} alt="deal-image" />
                      {deal?.title.toLowerCase().includes("night midweek") && (
                        <span className="price_label">
                          <strike>
                            {deal?.title
                              .toLowerCase()
                              .includes("2 night midweek")
                              ? "R3,000"
                              : "R6,000"}
                          </strike>{" "}
                          {deal?.title.toLowerCase().includes("2 night midweek")
                            ? "R1,399"
                            : "R2,199"}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="resturant-result-child-2">
                    {/* Restaurant details */}
                    <div className="resturant-details">
                      <div className="resturant-details-1">
                        <h1 style={{ color: "#3FAE49" }}>{deal?.title}</h1>
                        <p
                          style={{
                            color: deal?.title
                              .toLowerCase()
                              .includes("night midweek")
                              ? "#fff"
                              : "grey",
                          }}
                        >
                          {deal?.title.toLowerCase().includes("night midweek")
                            ? "Luxury, fully finished and serviced holiday accommodation for 2 people at a selection of stunning resorts country-wide."
                            : deal?.address}
                        </p>
                        <div
                          style={{
                            color: deal?.title
                              .toLowerCase()
                              .includes("night midweek")
                              ? "#fff"
                              : "darkgrey",
                          }}
                          className="deatils"
                        >
                          {deal?.title
                            .toLowerCase()
                            .includes("night midweek") ? (
                            <div className="resolts-list">
                              <h4>Available Resorts:</h4>
                              <ul>
                                <li>Midlands Saddle & Trout - KZN Midlands</li>
                                <li>La Montagne - Ballito</li>
                                <li>Mount Sierra - Cape Town</li>
                                {/* <li>Bushman's Nek - Drakensberg</li> */}
                                <li>Magalies Park - Hartebeespoort</li>
                                <li>Club Mykonos - Langebaan</li>
                                <li>Kowies Rivier Chalet - Port Alfred</li>
                                <li>Port Owen Marina - Velddrif</li>
                                <li>The Palace - Durban</li>
                              </ul>
                            </div>
                          ) : (
                            <div className="deatils-1">
                              <div className="d1-item1">
                                <h5>CONTACT NUMBER</h5>
                                {deal?.contact_number}
                                <br />
                                <br />
                                <br />
                                <h5>OPERATING HOURS</h5>
                                {deal?.opening_hours[0]}
                                <br />
                                <br />
                                <br />
                                <h5>DEAL</h5>
                                {deal?.description}
                              </div>
                              <div className="d1-item2">
                                <h5>WEBSITE</h5>
                                {deal?.website}
                                <br />
                                <br />
                                <br />
                                <h5>TYPE</h5>
                                {deal?.type}
                              </div>
                            </div>
                          )}
                          <br />
                          <button
                            id="view-deal"
                            style={{ color: "white" }}
                            className={`map-but ${
                              typeof window !== "undefined" &&
                              window.localStorage.getItem("flp-token")
                                ? ""
                                : "disabled"
                            }`}
                            onClick={() => {
                              if (
                                !(
                                  typeof window !== "undefined" &&
                                  window.localStorage.getItem("flp-token")
                                )
                              ) {
                                window.location.href = "/?p=login";

                                return;
                              }

                              setSelectedDeals4U(deal);

                              if (
                                deal?.title
                                  .toLowerCase()
                                  .includes("night midweek")
                              ) {
                                setShowTsAndCsModal(true);

                                return;
                              }

                              if (deal?.discount_image_path) {
                                setShowQrModal(false);
                                setShowImageModal(true);
                              } else if (deal?.qr_link !== "") {
                                setShowImageModal(false);
                                setShowQrModal(true);
                              }
                            }}
                            title={
                              !(
                                typeof window !== "undefined" &&
                                window.localStorage.getItem("flp-token")
                              ) && "You should log in to access this service"
                            }
                          >
                            {deal?.title.toLowerCase().includes("night midweek")
                              ? isLoading
                                ? "Please wait..."
                                : "PURCHASE VOUCHER"
                              : "VIEW DISCOUNT CODE"}
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* Restaurant details end */}
                  </div>
                  {/* Restaurant result end */}
                </div>
                <hr className="solid" />{" "}
                {/* This line adds a horizontal line after each restaurant result */}
              </React.Fragment>
            ))
          ) : (
            <div className="fetching-container">No Deal Found.</div>
          )
        ) : (
          <div className="fetching-container">Fetching Deals...</div>
        )}
      </div>

      {showQrModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => setShowQrModal(false)}>
              &times;
            </span>
            <QRCode
              value={selectedDeals4U?.qr_link}
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        </div>
      )}

      {showImageModal && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={() => setShowImageModal(false)}>
              &times;
            </span>
            <img
              src={selectedDeals4U?.discount_image_path}
              alt="discount-image"
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        </div>
      )}

      {showTsAndCsModal && (
        <div className="modal tscs-model">
          <div className="tscs-content">
            <div className="main-content">
              <h2>
                Voucher Terms & Conditions
                <span
                  className="tscs-close tscs-right"
                  onClick={() => setShowTsAndCsModal(false)}
                >
                  &times;
                </span>
              </h2>
              <p>
                This voucher is, valid for 12 months and entitles the bearer to
                2- or 4-nights' luxury, fully furnished and serviced
                accommodation for 2 adults at one of the selected resorts in a
                1-bedroom, 2 sleeper unit during midweek (Monday-Thursday), is
                not transferable and may not be redeemed for cash.
              </p>

              <p>
                This offer is for accommodation only and additional services
                such as telephone bill, room service, spa treatments, and
                laundry service, and any other meals/drinks and activities are
                not included.
              </p>

              <p>
                This offer is not valid during weekends, peak season, school and
                public holidays.
              </p>

              <p>
                Reservations can be made by phone or email and can only be made
                up to 6 weeks in advance and is subject to availability Prices
                shown are fully inclusive of taxes, levies and government
                charges current at the time of publication.
              </p>
              {/* add check button */}
              <label className="tscs-check-label" htmlFor="tscs-check">
                <input
                  type="checkbox"
                  id="tscs-check"
                  className="tscs-check"
                  title="check button"
                  onChange={(e) => setHasAcceptedTsAndCs(e.target.checked)}
                />
                I have read and agree to the terms and conditions
              </label>
              {/* proceed button */}
              <button
                id="view-deal"
                className={`tscs-proceed-btn tscs-right ${
                  !hasAcceptedTsAndCs || isLoading ? "tscs-disabled" : ""
                }`}
                onClick={() => {
                  requestVoucherData(
                    selectedDeals4U?.title
                      .toLowerCase()
                      .includes("2 night midweek")
                      ? 1399
                      : 2199
                  );
                }}
                title="proceed button"
                disabled={!hasAcceptedTsAndCs || isLoading}
              >
                {isLoading ? "Please Wait..." : "Proceed"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DealsFinder;
